angular.module('impactx.basket').controller('TemplateAndBasketListCtrl', [
    'selectedListItems',
    'basketTemplateMenu',
    '$redirect',
    '$securityManager',
    'dataGen',
    '$context',
    TemplateAndBasketListCtrl]);

function TemplateAndBasketListCtrl(selectedListItems, basketTemplateMenu, $redirect, $securityManager, dataGen, $context) {
    var self = this;

    self.getDetailLink = function () {
        return "basket/" + selectedListItems.getFirstSelectedId();
    };

    self.addToCurrentBasket = function () {
        basketTemplateMenu.addTemplateToBasket(selectedListItems.getFirstSelectedId()).then(function () {
            $redirect.redirectTo(null, "/basket");
        });
    };

    this.createBasket = function()
    {
        if ($securityManager.isProcessAllowed("CreateBasket"))
        {
            dataGen.post({}, {}, "/basket/create", function ()
            {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null,"/basket");
            });
        }
        else if ($securityManager.isProcessAllowed("CreateProposalBasket"))
        {
            dataGen.post({}, {}, "/basket/createproposal", function ()
            {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null,"/basket");
            });
        }
    };

    var buttonDefinition = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewBasket'},
        {label: "addToBasket", action: self.addToCurrentBasket, condition:  selectedListItems.isSingleSelection, process: 'AddTemplateToBasket'}
    ];

    self.meta = {
        rowTemplate: 'modules/basket/templates/templateandbasketlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/basket/templateandbasket/list',
        id: 'templateandbasketlist',
        mainActionFunction: {id:"new", action: this.createBasket, icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };

    self.getMeta = function () {
        return self.meta;
    };
}